import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SubHeader } from 'cstar-react-primitives';

import { useFormatMessage } from '../../intl/intlHooks';
import { useSegment } from '../../segment/SegmentProvider';
import {
    getDigitalQuantity,
    getPhysicalQuantity,
    selectDigitalLineItems,
    selectPhysicalLineItems
} from '../../lineItem/lineItemSelectors';

import { orderSummaryDetailsMessages } from './orderSummaryMessages';
import { LineItemListingFormik } from '../forms/lineItem/LineItemListingForm';

export const InnerOrderSummaryDetails = ({
    digitalLineItems,
    physicalLineItems,
    digitalQuantity,
    physicalQuantity
}) => {
    const { cartViewed } = useSegment();

    useEffect(() => {
        cartViewed([...digitalLineItems, ...physicalLineItems])
    }, [digitalQuantity, physicalQuantity]);

    const formatMessage = useFormatMessage();
    const egiftHeaderProps = {
        heading: formatMessage(orderSummaryDetailsMessages.egiftCardsLabel, {
            cartCount: digitalQuantity
        })
    };
    const physicalHeaderProps = {
        heading: formatMessage(orderSummaryDetailsMessages.physicalGiftCardsLabel, {
            cartCount: physicalQuantity
        })
    };
    return (
        <div>
            {(digitalLineItems.length > 0) && (
                <div className="line-item-group">
                    <SubHeader {...egiftHeaderProps} />
                    {digitalLineItems.map(lineItem => (
                        <LineItemListingFormik key={lineItem.id} lineItem={lineItem} />
                    ))}
                </div>
            )}
            {(physicalLineItems.length > 0) && (
                <div className="line-item-group">
                    <SubHeader {...physicalHeaderProps} />
                    {physicalLineItems.map(lineItem => (
                        <LineItemListingFormik key={lineItem.id} lineItem={lineItem} />
                    ))}
                </div>
            )}
        </div>
    );
};

InnerOrderSummaryDetails.propTypes = {
    digitalLineItems: PropTypes.array.isRequired,
    physicalLineItems: PropTypes.array.isRequired,
    digitalQuantity: PropTypes.number.isRequired,
    physicalQuantity: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
    digitalLineItems: selectDigitalLineItems(state),
    physicalLineItems: selectPhysicalLineItems(state),
    digitalQuantity: getDigitalQuantity(state),
    physicalQuantity: getPhysicalQuantity(state)
});

export const OrderSummaryDetails = connect(mapStateToProps)(InnerOrderSummaryDetails);
